export default ({
  theme,
  white,
  attach,
  nest,
  ICON,
  TEXT,
  LIST_SUBHEADER,
  LIST_ITEM_TEXT
}) => ({
  MuiListSubheader: {
    root: {
      zIndex: 0,
      fontWeight: 700,
      color: theme.palette.primary.dark,
      padding: '5px 10px',
      textAlign: 'left',
      lineHeight: '25px',
      borderBottom: '1px solid #e6ecf0',
      [attach(LIST_SUBHEADER.flex)]: {
        display: 'flex',
        alignItems: 'baseline',
        width: 'calc(100% - 16px)',
        [nest(TEXT.header)]: {
          width: '30%'
        }
      }
    },
    sticky: {
      zIndex: 0
    },
    gutters: {
      [theme.breakpoints.up('sm')]: {
        padding: '5px 10px'
      }
    }
  },
  MuiListItemText: {
    root: {
      [nest(TEXT.tertiary)]: {
        fontSize: 13,
        paddingTop: 5,
        [nest(ICON.root)]: {
          fontSize: 16,
          verticalAlign: 'text-bottom'
        }
      },
      [attach(LIST_ITEM_TEXT.flex)]: {
        width: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        [nest(LIST_ITEM_TEXT.primary)]: {
          width: '30%'
        },
        [nest(LIST_ITEM_TEXT.secondary)]: {
          width: '70%'
        }
      }
    },
    multiline: {
      margin: '0 !important'
    },
    primary: {
      color: theme.palette.primary.dark,
      fontSize: '14px'
    },
    secondary: {
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: '14px'
    }
  },
  MuiListItem: {
    root: {
      userSelect: 'initial'
    },
    gutters: {
      padding: '5px 10px',
      paddingLeft: 10,
      paddingRight: 10,
      [theme.breakpoints.up('sm')]: {
        padding: '5px 10px',
        paddingLeft: 10,
        paddingRight: 10
      }
    },
    button: {
      '&:hover': {
        backgroundColor: '#f5f8fa'
      }
    },
    focusVisible: {
      backgroundColor: 'rgba(230, 236, 240, 0.7)'
    }
  },
  MuiList: {
    padding: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 0
    }
  }
});
